import { render } from "./flightInfo.vue?vue&type=template&id=24aa9a06&scoped=true"
import script from "./flightInfo.vue?vue&type=script&lang=js"
export * from "./flightInfo.vue?vue&type=script&lang=js"

import "./flightInfo.vue?vue&type=style&index=0&id=24aa9a06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24aa9a06"]])

export default __exports__